import styled from "styled-components"
import { useStore } from "@state/store"
import ResidenceInfoCard from "./ResidenceInfoCard"

const FavouritesInfoCard = ({ unit, compare = false }) => {
  const contentControls = useStore((s) => s.contentControls)
  const currentSection =
    contentControls?.categories[contentControls?.index]?.toLowerCase()

  // this is for compare mode
  if (!Array.isArray(unit)) {
    unit = [unit]
  }

  const selectedUnit = unit[0]

  if (!selectedUnit || contentControls?.index === null) return null

  return (
    <Wrapper id="favouritesInfoCard" compare={compare} section={currentSection}>
      <div className="container">
        <ResidenceInfoCard unit={[selectedUnit]}/>
      </div>
    </Wrapper>
  )
}

export default FavouritesInfoCard

const Wrapper = styled.div<{ compare: boolean; section: string }>`
  width: 100%;
  height: 100%;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  text-transform: uppercase;
  padding: ${(props) => (props.compare ? "2em 2em" : "2em 0")};
  gap: 3em;
  width: ${(props) => (props.compare ? "80%" : "100%")};

  .container{
    width: 100%;
    #residenceInfoCard{
      margin: 0;
      border: none;
    }
    .eco-info{
      display: none;
    }
  }
`
